import { render } from "./PlanDistributions.vue?vue&type=template&id=80fa07d0&scoped=true"
import script from "./PlanDistributions.vue?vue&type=script&lang=js"
export * from "./PlanDistributions.vue?vue&type=script&lang=js"

import "./PlanDistributions.vue?vue&type=style&index=0&id=80fa07d0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80fa07d0"]])

export default __exports__